import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GenericComponent } from 'src/app/core/util/abstract/generic-component';
import { AddStakeholdersActionComponent } from '../../modal/add-stakeholders-task/add-stakeholders-action.component';
import { modalConfig, ModalEnum } from 'src/app/core/util/modalConfig';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { SearchService } from 'src/app/core/service/api/search.service';
import { getBatchIds, overviewFilterSet } from 'src/app/akita/batch/batch';
import { catchError, finalize, Subscription, tap } from 'rxjs';
import moment from 'moment';
import { ExcelServiceService } from 'src/app/core/service/api/excel-service.service';
import { DeletionModalComponent } from '../../modal/deletion-modal/deletion-modal.component';
import { translate } from '@jsverse/transloco';
import { showFeedbackError, showFeedbackRemoved, showFeedbackSaved } from 'src/app/core/util/notification';
import { IntegrationsService } from 'src/app/core/service/integrations.service';
import { CreateBatchDialogItemsComponent } from '../../modal/create-batch-dialog-items/create-batch-dialog-items.component';
import { BatchAttachItemsComponent } from '../../modal/batch-attach-items/batch-attach-items.component';
import { CachedService } from 'src/app/core/service/common/cached.service';
import { Globals } from 'src/app/globals';
import { getColorCode } from 'src/app/core/util/color';
import { SharedProjectService } from 'src/app/core/service/api/shared-project.service';
import { userRoleFinder } from 'src/app/core/util/userDropDownPermission';
import { SubprojectQuery } from 'src/app/akita/subproject/state/subprojects.query';
import { PubsubService } from 'src/app/core/service/api/pubsub.service';

@Component({
  selector: 'app-batch-snackbar',
  templateUrl: './batch-snackbar.component.html',
  styleUrls: ['./batch-snackbar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatchSnackbarComponent extends GenericComponent implements OnChanges, OnInit, OnDestroy {
  @Input() type: string;
  @Input() ItemsShareType: string;
  @Input() name: string;
  @Input() items: any[] = [];
  @Input() paginator: any;
  @Input() overviewType: any;
  @Input() modal: string = 'overview';
  @Input() filters: boolean = false;
  @Input() typeObjThemeData: any[] = [];
  @Input() themeType: any = '';
  @Input() uniqueId: string = '';
  @Input() textMultiple: string = '';
  @Input() textSingle: string = '';
  @Input() iconsState: {} = { users: false, themes: false, object: false };
  @Input() selectedTheme: any[] = [];
  @Input() selectedUsers: any[] = [];
  @Input() selectedObject: any;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onloadItem: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onCloseSnackbar: EventEmitter<any> = new EventEmitter();
  public statusFilter: string = '';
  public fileName: string = '';
  public hasNonSmartReportingEntry = false;
  public users: any[];
  public subprojects: any[];
  public entity: any = {};
  isOpen: boolean = false;
  isThemeOpen: boolean = false;
  isObjectOpen: boolean = false;
  isSubprojectOpen: boolean = false;
  isSharedSubproject = signal<boolean>(false);
  isShareItemOpen: boolean = false;
  allProjects: any[] = [];
  selectedSharedProjects: any[] = [];
  selectedVisibleSharedProjects: any[] = [];
  private hiddenSharedConnectionObjects: any[] = [];
  private allSharedProjectsRaw: any[] = [];
  private lastBatchThemeUpdateKey = '';
  private lastBatchThemeUpdateAt = 0;
  private lastCreatedThemeUpdateKey = '';
  private lastCreatedThemeUpdateAt = 0;
  private recentlyCreatedThemeIds = new Set<number>();
  private recentlyCreatedThemeSelectionUntil = 0;
  private themeCreationSubscriptions = new Subscription();
  commonUsers: any[] = [];
  allTypes: string[] = ['stakeholders', 'employees', 'issues', 'decisions', 'actions', 'logs', 'permits', 'complaints', 'documents'];
  isReader = false;
  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private _searchService: SearchService,
    private excelService: ExcelServiceService,
    private _integrationService: IntegrationsService,
    private _cachedService: CachedService,
    private sharedProjectService: SharedProjectService,
    public globals: Globals,
    private subProjectQuery: SubprojectQuery,
    private pubsub: PubsubService,
    private eRef: ElementRef
  ) {
    super(globals);
  }

  private ensureArray(value: any): any[] {
    return Array.isArray(value) ? value : value ? [value] : [];
  }

  private ensureEntityArray(value: any): any[] {
    return this.ensureArray(value).filter(item => item && item.id);
  }

  private get createdThemeSourceId(): string {
    return this.uniqueId || 'batch-theme';
  }

  ngOnChanges(): void {
    if (this.type === 'decisions' || this.type === 'complaints') {
      this.hasNonSmartReportingEntry = this.items.some(obj => obj.entry_type !== "smart_reporting");
    }
    this.commonUsers = [...this.selectedUsers];

    // for theme & types of all modules
    if (this.themeType) {
      this.selectedTheme = Array.from(
        new Map(
          this.items
            .flatMap(item => this.ensureEntityArray(item[this.themeType === 'themedecisions' ? 'theme_requirements' : this.themeType]))
            .map(type => [type.id, type])
        ).values()
      );
    }
    // for requriement object field
    if (this.themeType === 'themedecisions') {
      this.selectedObject = Array.from(
        new Map(
          this.items
            .flatMap(item => this.ensureEntityArray(item.types))
            .map(type => [type.id, type])
        ).values()
      )
    }

    if (this.modal !== 'restore' && this.type !== 'employees' && this.type !== 'documents') {
      this.selectedUsers = Array.from(
        new Map(
          this.items
            .flatMap(item => this.ensureEntityArray(item.users))
            .map(user => [user.id, user])
        ).values()
      )
    }
    if (this.allTypes.includes(this.type)) {
      this.subprojects = Array.from(
        new Map(
          this.items.flatMap(item => this.ensureEntityArray(item.subprojects)).map(type => [type.id, type])
        ).values()
      );
    }
    if (this.allTypes.includes(this.type)||this.type.includes('documents')) { 
      this.syncSelectedSharedProjects();
    }
  }

  ngOnInit(): void {
    const activeSubProject = this.subProjectQuery.getActive();
    this.isSharedSubproject.set(activeSubProject && activeSubProject?.tenant_type === 'shared');
    this.isReader = this.computeIsReader();
    // Initialize entity.users if not already done
    if (!this.entity.users) {
      this.entity.users = [];
    }
    this._cachedService.getUsers().subscribe((users) => {
      this.users = users
    });
    this.sharedProjectService.getSharedProjects().subscribe((projects)=>{
      this.allSharedProjectsRaw = projects ?? [];
      this.globals.shared_projects = this.filterSharedProjectsByTypeAndModule(projects);
      this.allProjects = this.globals.shared_projects
        .filter(proj => proj.shared_level === 'read')
        .map(proj => ({ color: getColorCode(), ...proj }))
        .filter(proj => proj.modules?.some((m: any) => m.module_id === (this.ItemsShareType === 'permits' ? 'permit' : this.ItemsShareType)));
      this.allProjects = this.dedupeById(this.allProjects);
      this.syncSelectedSharedProjects();
    });
    this.themeCreationSubscriptions.add(this.pubsub.createdThemeType.subscribe(payload => {
      if (
        this.items.length &&
        this.themeType &&
        payload?.sourceUniqueId === this.createdThemeSourceId &&
        payload?.type === this.themeType
      ) {
        const createdThemes = this.findCreatedThemesFromResponse(payload.response, payload.payload);
        if (createdThemes.length) {
          this.updateBatchCreatedThemes(createdThemes);
        }
      }
    }));
  }

  ngOnDestroy(): void {
    this.themeCreationSubscriptions.unsubscribe();
  }

  private findCreatedThemesFromResponse(response: any, payload: any): any[] {
    const entries = response?.id
      ? [response]
      : Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response)
          ? response
          : [];
    const createdNames = new Set(
      (payload?.save || [])
        .map((item: any) => (item?.name || item?.description || '').trim().toLowerCase())
        .filter(Boolean)
    );

    if (!entries.length || !createdNames.size) {
      return [];
    }

    const exactMatches = entries.filter((entry: any) => {
      const label = (entry?.name || entry?.description || '').trim().toLowerCase();
      return createdNames.has(label);
    });
    if (exactMatches.length) {
      return exactMatches;
    }

    return entries
      .slice()
      .sort((a: any, b: any) => +b.id - +a.id)
      .slice(0, createdNames.size);
  }

  //on open action module
  public openActionModal() {
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isObjectOpen = false;
    const dialog = this.dialog.open(AddStakeholdersActionComponent, modalConfig({
      data: { stakeholders: this.items, batch: true },
      panelClass: 'customized-dialog-container',
    }, ModalEnum.ModalDefault));
    dialog.afterClosed().subscribe(() => {
      this.onloadItem.emit(false);
    });
  }

  //on export overview
  public onExport(batch?) {
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isObjectOpen = false;
    this.route.queryParamMap.subscribe((paramMap: ParamMap) => {
      this.statusFilter = paramMap.get('status') || 'open';
    });
    this._searchService.exportFilterOverview(overviewFilterSet(this.paginator, batch, getBatchIds(this.items), this.statusFilter, this.type), this.overviewType)
      .pipe(
        tap(res => {
          if (res.type == 'application/octet-stream') {
            this.fileName = `${this.globals.projectCode}_${this.type}_${moment().format('YYYY.MM.DD')}.zip`;
          } else {
            this.fileName = `${this.globals.projectCode}_${this.type}_${moment().format('YYYY.MM.DD')}.xlsx`;
          }
          this.excelService.saveBlobAsFile(res, this.fileName);
        })
      ).subscribe();
  }

  //on batch deletion
  public onDelete(): void {
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isObjectOpen = false;
    const list = getBatchIds(this.items);
    const dialogRef = this.dialog.open(DeletionModalComponent, {
      data: translate('delete_item')
    });
    dialogRef.afterClosed().subscribe((remove: boolean) => {
      if (remove) {
        this._searchService.batchDeletion(this.type, list)
          .pipe(
            finalize(() => {
              showFeedbackRemoved();
              this.onloadItem.emit(true);
            }),
            catchError(async (err) => showFeedbackError(err))
          ).subscribe();
      }
    })
  }

  public onUpgradeDowngradeComplaint() {
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isObjectOpen = false;
    if (!this.hasNonSmartReportingEntry) {
      const ids = { ids: getBatchIds(this.items).map(id => ({ id })) };
      this._integrationService.upgradeDowngradeComplaints(this.type, ids)
        .pipe(
          tap(() => {
            showFeedbackSaved();
            this.onloadItem.emit(true);
          }),
          catchError(async (err) => showFeedbackError(err))
        ).subscribe();
    }
  }

  public createBatchDialogItems() {
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isObjectOpen = false;
    const dialog = this.dialog.open(CreateBatchDialogItemsComponent, modalConfig({
      data: { layers: this.items },
      panelClass: 'customized-dialog-container',
    }, ModalEnum.ModalSmall));
    dialog.afterClosed().subscribe(() => {
      this.onloadItem.emit(true);
    });
  }

  public openBatchLayersModal() {
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isObjectOpen = false;
    const dialog = this.dialog.open(BatchAttachItemsComponent, modalConfig({
      data: { layers: this.items },
      panelClass: 'customized-dialog-container',
    }, ModalEnum.ModalSmall));
    dialog.afterClosed().subscribe(() => {
      this.onloadItem.emit(true);
    });
  }

  //on batch restore
  public onRestore(): void {
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isObjectOpen = false;
    const list = getBatchIds(this.items);
    const dialogRef = this.dialog.open(DeletionModalComponent, {
      data: { type: 'restore', text: translate('restore_item') }
    });
    dialogRef.afterClosed().subscribe((remove: boolean) => {
      if (remove) {
        this._searchService.batchRestore(this.type, list)
          .pipe(
            tap(() => {
              showFeedbackSaved();
              this.onloadItem.emit(true);
            }),
            catchError(async (err) => showFeedbackError(err))
          ).subscribe();
      }
    })
  }

  updateBatchThemes(selected: any[], type) {
    selected = this.ensureEntityArray(selected);
    if (
      type === 'themeType' &&
      Date.now() < this.recentlyCreatedThemeSelectionUntil &&
      selected.some(item => this.recentlyCreatedThemeIds.has(item.id))
    ) {
      return;
    }
    const updateKey = JSON.stringify({
      type,
      ids: selected.map(item => item.id).sort(),
      itemIds: this.items.map(item => item.id).sort(),
    });
    const now = Date.now();
    if (updateKey === this.lastBatchThemeUpdateKey && now - this.lastBatchThemeUpdateAt < 500) {
      return;
    }
    this.lastBatchThemeUpdateKey = updateKey;
    this.lastBatchThemeUpdateAt = now;
    // Step 1: Remove types/themes that were preselected(common)

    // get theme/type property based on this.themeType
    let typeTheme = this.themeType === 'themedecisions' ? 'theme_requirements' : this.themeType;
    const updatedThemesTypes = this.items.map(item => {
      if (type === 'themeType' || type === 'object') {
        // for requirements object field property name is types
        typeTheme = type === 'object' ? 'types' : typeTheme;

        // Step 1: filter if the type already exsits
        this.items.forEach(item => {
          item[typeTheme] = this.ensureEntityArray(item[typeTheme]).filter(type =>
            selected.some(select => select.id === type.id)
          );
        });
  
        // Step 2: Identify newly added types (types in selectedTypes but not in any selectionItems)
        const existingTypes = new Set(
          this.items.flatMap(item => this.ensureEntityArray(item[typeTheme]).map(type => type.id))
        );
        const newTypes = selected.filter(type => !existingTypes.has(type.id));
  
        // Step 3: Add only newly added types to all selectionItems
        this.items.forEach(item => {
          newTypes.forEach(newType => {
            item[typeTheme].push(newType);
          });
        });

        return {
          id: item.id,
          [typeTheme]: [...item[typeTheme]], // Add type/theme if not there already
        }
      }

      if (type === 'users') {
        this.items.forEach(item => {
          item.users = this.ensureEntityArray(item.users).filter(user =>
            selected.some(select => select.id === user.id)
          )
        });

        // Step 2: Identify newly added types (types in selectedTypes but not in any selectionItems)
        const existingUsers = new Set(
          this.items.flatMap(item => this.ensureEntityArray(item.users).map(user => user.id))
        );
        const newUsers = selected.filter(user => !existingUsers.has(user.id));
  
        // Step 3: Add only newly added types to all selectionItems
        this.items.forEach(item => {
          newUsers.forEach(newUser => {
            item.users.push(newUser);
          });
        });

        return {
          id: item.id,
          users: [...item.users]
        };
      }

      if (type === 'subprojects') {
        this.items.forEach(item => {
          // Step 1: Remove unselected subprojects
          item.subprojects = this.ensureEntityArray(item.subprojects).filter(sub =>
            selected.some(select => select.id === sub.id)
          );
        });

        // Step 2: Identify new subprojects
        const existingSubprojectIds = new Set(
          this.items.flatMap(item => this.ensureEntityArray(item.subprojects).map(sub => sub.id))
        );
        const newSubprojects = selected.filter(sub => !existingSubprojectIds.has(sub.id));

        // Step 3: Add new subprojects to all items
        this.items.forEach(item => {
          newSubprojects.forEach(newSub => {
            item.subprojects.push(newSub);
          });
        });
        return {
          id: item.id,
          subprojects: [...item.subprojects]
        };
      }
    });
    const typeToSend = this.type === 'employees' ? 'contactpersons' : this.type === 'logs' ? 'contactmoments' : this.type;
    this.sendBatchUpdate(updatedThemesTypes, typeToSend);
  }

  updateBatchCreatedThemes(createdThemes: any[]): void {
    const created = this.ensureEntityArray(createdThemes);
    if (!created.length || !this.items.length || !this.themeType) {
      return;
    }

    const typeTheme = this.themeType === 'themedecisions' ? 'theme_requirements' : this.themeType;
    const updateKey = JSON.stringify({
      type: 'createdTheme',
      ids: created.map(item => item.id).sort(),
      itemIds: this.items.map(item => item.id).sort(),
    });
    const now = Date.now();
    if (updateKey === this.lastCreatedThemeUpdateKey && now - this.lastCreatedThemeUpdateAt < 1000) {
      return;
    }
    this.lastCreatedThemeUpdateKey = updateKey;
    this.lastCreatedThemeUpdateAt = now;
    this.recentlyCreatedThemeIds = new Set(created.map(item => item.id));
    this.recentlyCreatedThemeSelectionUntil = now + 1000;

    const updatedThemesTypes = this.items.map(item => {
      const merged = this.dedupeEntities([
        ...this.ensureEntityArray(item[typeTheme]),
        ...created,
      ]);
      item[typeTheme] = merged;

      return {
        id: item.id,
        [typeTheme]: [...merged],
      };
    });

    const typeToSend = this.type === 'employees' ? 'contactpersons' : this.type === 'logs' ? 'contactmoments' : this.type;
    this.sendBatchUpdate(updatedThemesTypes, typeToSend);
  }

  private dedupeEntities(items: any[]): any[] {
    return Array.from(
      new Map(
        this.ensureEntityArray(items).map(item => [item.id, item])
      ).values()
    );
  }

  private sendBatchUpdate(updatedThemesTypes: any[], typeToSend: string): void {
    if (!updatedThemesTypes.length) {
      return;
    }

    this._searchService.batchUpdateThemes(updatedThemesTypes, typeToSend).subscribe((res) => {
      if (res) {
        showFeedbackSaved();
        this.onloadItem.emit(false);
      }
    });
  }

  onClose(): void {
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isSubprojectOpen = false;
    this.isShareItemOpen = false;
    this.onCloseSnackbar.emit(true);
  }

  onUserClick() {
    this.isThemeOpen = false;
    this.isObjectOpen = false
    this.isSubprojectOpen = false;
    this.isShareItemOpen = false;
    this.isOpen = !this.isOpen;
  }

  onThemeClick() {
    this.isOpen = false;
    this.isObjectOpen = false;
    this.isSubprojectOpen = false;
    this.isShareItemOpen = false;
    this.isThemeOpen = !this.isThemeOpen;
  }

  onObjectClick() {
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isSubprojectOpen = false;
    this.isShareItemOpen = false;
    this.isObjectOpen = !this.isObjectOpen
  }

  onClickSubproject(){
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isObjectOpen = false;
    this.isShareItemOpen = false;
    this.isSubprojectOpen = !this.isSubprojectOpen;
  }
  
  private computeIsReader(): boolean {
    try {
      const data = this.globals.user?.scope?.data;
      if (!Array.isArray(data) || data.length === 0) return false;
      return !!userRoleFinder(this.globals);
    } catch {
      return false;
    }
  }

  onClickShareItem(){
    this.isOpen = false;
    this.isThemeOpen = false;
    this.isObjectOpen = false;
    this.isSubprojectOpen = false;
    this.isShareItemOpen = !this.isShareItemOpen;
  }

  private syncSelectedSharedProjects(): void {
    if (!this.items.length) return;
    const sharedProjectStatusMap = new Map<number, string>();
    for (const sp of this.items.flatMap((item: any) => item?.shared_projects_with_item_status ?? [])) {
      const existing = sharedProjectStatusMap.get(sp.project_id);
      if (!existing || sp.status === 'accepted') {
        sharedProjectStatusMap.set(sp.project_id, sp.status);
      }
    }
    const otherProjectId = (project: any) => project.side === 'source' ? project.target_project_id : project.source_project_id;
    if (this.allProjects.length) {
      this.allProjects = this.allProjects.map((project: any) => {
        const status = sharedProjectStatusMap.get(otherProjectId(project));
        const isAccepted = status === 'accepted';
        return { ...project, is_disabled: isAccepted, status: status ?? project.status };
      });
      this.selectedVisibleSharedProjects = this.allProjects.filter((p: any) => sharedProjectStatusMap.has(otherProjectId(p)));
    }
    const allProjectIds = new Set(this.allProjects.map((p: any) => p.id));
    this.hiddenSharedConnectionObjects = this.allSharedProjectsRaw
      .filter((p: any) => sharedProjectStatusMap.has(otherProjectId(p)) && !allProjectIds.has(p.id))
      .map((p: any) => ({ color: getColorCode(), ...p }));
    this.selectedSharedProjects = [...this.hiddenSharedConnectionObjects, ...this.selectedVisibleSharedProjects];
  }

  onBatchSharedSelectionChange(event: any[]): void {
    this.selectedVisibleSharedProjects = event ?? [];
    this.updateBatchSharedItems();
  }

  updateBatchSharedItems(): void {
    const merged = this.dedupeById([...this.hiddenSharedConnectionObjects, ...this.selectedVisibleSharedProjects]);
    const itemIds = this.items.map(i => i.id);
    const payload = { item_ids: [...itemIds], shared_projects: merged };
    this.sharedProjectService.updateBulkSharedItems(this.ItemsShareType, payload).subscribe(() => {
      showFeedbackSaved();
      this.onloadItem.emit(false);
    });
  }

  private dedupeById(arr: any[]): any[] {
    if (!Array.isArray(arr)) return [];
    return Array.from(new Map(arr.map(p => [p.id, p])).values());
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {  
    const target = event.target as HTMLElement;
    const clickedInsideOverlay = !!target?.closest?.('.cdk-overlay-container');
    if (!this.eRef.nativeElement.contains(event.target) && !clickedInsideOverlay && target?.getAttribute?.('name') !== 'subproject-checkbox') {
      this.isOpen = false;
      this.isThemeOpen = false;
      this.isObjectOpen = false;
      this.isSubprojectOpen = false;
      this.isShareItemOpen = false;
    }
  }
}
